export const changeInList = (list, item) => {
    if (!item.id) {
        list.push(item)
        return [
            ...list,
        ]
    }

    list = list.filter(listItem => {
        return listItem.id !== item.id
    })
    list.push(item)
    return [
        ...list,
    ]
}



// WEBPACK FOOTER //
// ./src/util/reducer-helper.js